import http from './http';
import { UrlPathENUM } from './constants';
import type { ActiveTableResponseType, GetAddressesResponseType } from './api.types';

const getAddressesByPostcode = async (params: { postcode: string; apiKey: string }) => {
  const { apiKey, ...restParams } = params;
  const response = await http.get<GetAddressesResponseType>(UrlPathENUM.ADDRESS, {
    params: restParams,
    headers: {
      'X-Api-Key': apiKey,
    },
  });
  return response;
};

const getAddressesByText = async (params: { text: string; apiKey: string }) => {
  const { apiKey, ...restParams } = params;
  const response = await http.get<GetAddressesResponseType>(UrlPathENUM.ADDRESS_FUZZY, {
    params: restParams,
    headers: {
      'X-Api-Key': apiKey,
    },
  });
  return response;
};

const getAddressesByTextOrPostcode = async (params: { text: string; apiKey: string }) => {
  const { apiKey, ...restParams } = params;
  const response = await http.get<GetAddressesResponseType>(UrlPathENUM.ADDRESS_TEXT_OR_POSTCODE, {
    params: restParams,
    headers: {
      'X-Api-Key': apiKey,
    },
  });
  return response;
};

const clearReverseTable = async () => {
  return http.delete(UrlPathENUM.ADDRESS_RESERVE);
};

const toggleTable = async () => {
  return http.patch<ActiveTableResponseType>(UrlPathENUM.ADDRESS_ACTIVE);
};

const getActiveTableInfo = async () => {
  return http.get<ActiveTableResponseType>(UrlPathENUM.ADDRESS_ACTIVE);
};

const uploadFiles = async (files: FormData) => {
  return http.post<{ message: string }>(UrlPathENUM.ADDRESS_FILES, files);
};

const clearQueue = async () => {
  return http.post(UrlPathENUM.ADDRESS_PURGE);
};

export default {
  getAddressesByPostcode,
  getAddressesByText,
  getAddressesByTextOrPostcode,
  clearReverseTable,
  toggleTable,
  getActiveTableInfo,
  uploadFiles,
  clearQueue,
};
